function wireBurgerToggle() {
  const btn   = document.querySelector("[data-nav-toggle]");
  const menus = Array.from(document.querySelectorAll("[data-nav-menu]"));
  if (!btn || menus.length === 0) return;

  const open  = () => { document.body.classList.add("nav-open");  btn.setAttribute("aria-expanded","true");  };
  const close = () => { document.body.classList.remove("nav-open"); btn.setAttribute("aria-expanded","false"); };

  btn.addEventListener("click", () => {
    document.body.classList.contains("nav-open") ? close() : open();
  });

  // close when a link is clicked
  menus.forEach(m => m.addEventListener("click", (e) => {
    if (e.target.closest("a")) close();
  }));

  // close on outside click
  document.addEventListener("click", (e) => {
    if (document.body.classList.contains("nav-open") && !e.target.closest(".site-header")) close();
  });

  // Esc closes
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });

  // on resize to desktop, reset
  const bp = 1024;
  const onResize = () => { if (window.innerWidth > bp) close(); };
  window.addEventListener("resize", onResize);
  onResize();
}

// make sure it RUNS
document.addEventListener("DOMContentLoaded", () => {
  wireBurgerToggle();
});


if (!window.__afvbyCountdownInit) {
  window.__afvbyCountdownInit = true;
  (function(){
    function pad(n){ return String(n).padStart(2,'0'); }
    function tick(){
      var now = Date.now();
      document.querySelectorAll('[data-countdown-ts]').forEach(function(el){
        var tsSec = Number(el.getAttribute('data-countdown-ts'));
        if (!tsSec) return;
        var diff = Math.max(0, tsSec*1000 - now);
        var s = Math.floor(diff/1000);
        var d = Math.floor(s/86400); s -= d*86400;
        var h = Math.floor(s/3600);  s -= h*3600;
        var m = Math.floor(s/60);    s -= m*60;

        if (diff <= 0) {
          el.innerHTML = '<span class="live">LIVE</span>';
          return;
        }
        el.innerHTML =
          '<span class="cd d">'+d+'</span><span class="unit"> Days</span> '+
          '<span class="sep">-</span> '+
          '<span class="cd h">'+pad(h)+'</span><span class="sep">:</span>'+
          '<span class="cd m">'+pad(m)+'</span><span class="sep">:</span>'+
          '<span class="cd s">'+pad(s)+'</span>';
      });
    }
    tick();
    setInterval(tick, 1000);
  })();
}
document.addEventListener('DOMContentLoaded', () => {
  // Limit to this page’s group (change the selector if you prefer)
  const accordions = Array.from(document.querySelectorAll('#schedule-accordions details.sched'));
  accordions.forEach(d => {
    d.addEventListener('toggle', () => {
      if (d.open) {
        accordions.forEach(other => {
          if (other !== d) other.removeAttribute('open'); // close siblings
        });
      }
    });
  });
});
